import { Component } from '@angular/core';
import { IFormGroup } from '@shared-libs/interfaces';
import { Action } from '@shared-libs/enums';
import { NavigationService } from '@shared-services/navigation.service';
import { formIsValid } from '@shared-libs/helpers';
import { IClient } from '@internal-models/client.model';
import { ClientProvider } from '@internal-providers/client.provider';
import { ClientFormFactory } from '@internal-factories/forms/client-form.factory';

@Component({
	selector: 'create-client-component',
	templateUrl: 'create-client.component.html',
	styleUrls: ['./create-client.component.scss'],
})
export class CreateClientComponent {
	public clientForm: IFormGroup<Partial<IClient>>;

	constructor(
		private readonly navigationService: NavigationService,
		private readonly provider: ClientProvider
	) {
		this.initializeForm();
	}

	public initializeForm(): void {
		this.clientForm = ClientFormFactory.createForClientsPage();
	}

	public async create(): Promise<void> {
		if (formIsValid(this.clientForm, CreateClientComponent)) {
			await this.provider.create(ClientFormFactory.getValue(this.clientForm));
			this.navigationService.navigateBack({ action: Action.CREATE });
		}
	}
}
